var quoteQuestionsResponse = require('./quote-questions.json');
export default quoteQuestionsResponse;
